module.exports = __webpack_public_path__ + "static/img/planner.ab963be.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/read/planner.png
// module id = ITok
// module chunks = 0